import React from 'react';
import {IconButton as Btn, IconButtonProps} from '@mui/material';
import {PWMLink} from './PWMLink';

const PWMIconButtonLink: React.FC<IPWMIconButtonLinkProps> = React.forwardRef((props, ref) => {
  const {children, ...rest} = props;
  const otherProps: IPWMIconButtonLinkProps = {
    ...rest,
    // @ts-ignore
    component: PWMLink
  };
  return (
    <Btn {...otherProps} ref={ref}>{children}</Btn>
  );
});

export default PWMIconButtonLink;

interface IPWMIconButtonLinkProps extends IconButtonProps {
  href?: string;
}